import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React, { Component } from 'react';
import OverheadPanel from './ResourcePanels/OverheadPanel';
import EquipmentPanel from './ResourcePanels/EquipmentPanel';
import AircraftPanel from './ResourcePanels/AircraftPanel';
import CrewsPanel from './ResourcePanels/CrewsPanel';
import OverheadGroupsPanel from "./ResourcePanels/OverheadGroupsPanel";

class ResourceCategoryNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPanel: 'overhead'
    };

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(evt, newTabValue) {
    this.setState({ selectedPanel: newTabValue });
  }

  render() {
    const { selectedPanel } = this.state;
    return (
      <div>
        <Paper>
          <Tabs
            value={selectedPanel}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleTabChange}
          >
            <Tab
              aria-controls="overhead-panel"
              id="overhead-tab"
              label="Overhead"
              value="overhead"
            />
            <Tab
              aria-controls="equipment-panel"
              id="equipment-tab"
              label="Equipment"
              value="equipment"
            />
            <Tab
              aria-controls="aircraft-panel"
              id="aircraft-tab"
              label="Aircraft"
              value="aircraft"
            />
            <Tab
              aria-controls="crews-panel"
              id="crews-tab"
              label="Crews"
              value="crews"
            />
            <Tab
              aria-controls="overheadgroups-panel"
              id="overheadgroups-tab"
              label="Groups: Aircraft, Overhead, Equipment"
              value="overheadgroups"
            />
          </Tabs>
        </Paper>
        <Paper>
          <OverheadPanel selectedPanel={selectedPanel} />
          <EquipmentPanel selectedPanel={selectedPanel} />
          <AircraftPanel selectedPanel={selectedPanel} />
          <CrewsPanel selectedPanel={selectedPanel} />
          <OverheadGroupsPanel selectedPanel={selectedPanel} />
        </Paper>
      </div>
    );
  }
}

export default ResourceCategoryNav;



// WEBPACK FOOTER //
// ./src/components/dispatches/ResourceCategoryNav.js